module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Loader-a696b291817ad9821aa4f28844673adf.svg";